import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const ConfettiShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M4.01207 15.7618L5.70156 10.6933C6.46758 8.39525 6.85059 7.24623 7.75684 7.03229C8.6631 6.81835 9.51953 7.67478 11.2324 9.38764L14.6114 12.7666C16.3242 14.4795 17.1807 15.3359 16.9667 16.2422C16.7528 17.1484 15.6038 17.5314 13.3057 18.2975L8.23724 19.987C5.47183 20.9088 4.08912 21.3697 3.35924 20.6398C2.62936 19.9099 3.09026 18.5272 4.01207 15.7618Z"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.2351 18.3461C12.2351 18.3461 11.477 16.0649 11.477 14.5552C11.477 13.0454 12.2351 10.7643 12.2351 10.7643M8.06517 19.4833C8.06517 19.4833 7.42484 16.7314 7.307 14.9343C7.11229 11.965 8.06517 7.35254 8.06517 7.35254"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.5093 10.0061L14.6533 9.28614C14.7986 8.55924 15.3224 7.96597 16.0256 7.73155C16.7289 7.49714 17.2526 6.90387 17.398 6.17697L17.542 5.45703"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17.5693 13.2533L17.7822 13.3762C18.4393 13.7556 19.2655 13.6719 19.8332 13.1685C20.3473 12.7126 21.0794 12.597 21.709 12.8723L22.0005 12.9997"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.79489 2.77903C9.4574 3.33109 9.54198 4.04247 9.99951 4.5L10.0974 4.59788C10.4906 4.99104 10.6355 5.56862 10.4746 6.10085"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.92761 3.94079C7.13708 3.73132 7.47669 3.73132 7.68616 3.94079C7.89563 4.15026 7.89563 4.48988 7.68616 4.69935C7.47669 4.90882 7.13708 4.90882 6.92761 4.69935C6.71814 4.48988 6.71814 4.15026 6.92761 3.94079Z"
      fill={fillColor}
    />
    <path
      d="M12.1571 7.1571C12.3666 6.94763 12.7062 6.94763 12.9157 7.1571C13.1251 7.36657 13.1251 7.70619 12.9157 7.91566C12.7062 8.12512 12.3666 8.12512 12.1571 7.91566C11.9476 7.70619 11.9476 7.36657 12.1571 7.1571Z"
      fill={fillColor}
    />
    <path
      d="M17.1571 10.1571C17.3666 9.94763 17.7062 9.94763 17.9157 10.1571C18.1251 10.3666 18.1251 10.7062 17.9157 10.9157C17.7062 11.1251 17.3666 11.1251 17.1571 10.9157C16.9476 10.7062 16.9476 10.3666 17.1571 10.1571Z"
      fill={fillColor}
    />
    <path
      d="M19.058 15.3134C19.2674 15.1039 19.6071 15.1039 19.8165 15.3134C20.026 15.5228 20.026 15.8624 19.8165 16.0719C19.6071 16.2814 19.2674 16.2814 19.058 16.0719C18.8485 15.8624 18.8485 15.5228 19.058 15.3134Z"
      fill={fillColor}
    />
    <path
      d="M19.3618 7.71436C18.6915 8.38463 19.1725 10.328 19.1725 10.328C19.1725 10.328 21.1158 10.809 21.7861 10.1387C22.496 9.42884 22.0943 8.49708 21.0005 8.5C21.0034 7.40615 20.0716 7.00447 19.3618 7.71436Z"
      stroke={fillColor}
      strokeLinejoin="round"
    />
    <path
      d="M15.1881 3.41748L15.1605 3.51459C15.1302 3.62126 15.1151 3.67459 15.1222 3.72695C15.1294 3.77931 15.1581 3.82476 15.2154 3.91567L15.2677 3.99844C15.4695 4.31836 15.5704 4.47831 15.5017 4.60915C15.4329 4.73998 15.24 4.75504 14.8542 4.78517L14.7543 4.79296C14.6447 4.80152 14.5899 4.8058 14.542 4.83099C14.494 4.85618 14.4584 4.89943 14.3872 4.98592L14.3224 5.06467C14.0718 5.36905 13.9465 5.52124 13.8035 5.50167C13.6606 5.4821 13.5947 5.30373 13.4629 4.94699L13.4288 4.85469C13.3914 4.75332 13.3726 4.70263 13.3358 4.66584C13.2991 4.62905 13.2484 4.61033 13.147 4.57287L13.0547 4.53878C12.698 4.40698 12.5196 4.34108 12.500 4.19815C12.4805 4.05522 12.6326 3.92992 12.937 3.67932L13.0158 3.61448C13.1023 3.54327 13.1455 3.50767 13.1707 3.45974C13.1959 3.41181 13.2002 3.35699 13.2087 3.24735L13.2165 3.14753C13.2466 2.76169 13.2617 2.56877 13.3925 2.50001C13.5234 2.43124 13.6833 2.53217 14.0033 2.73403L14.086 2.78626C14.1769 2.84362 14.2224 2.8723 14.2747 2.87947C14.3271 2.88664 14.3804 2.87148 14.4871 2.84117L14.5842 2.81358C14.9596 2.70692 15.1472 2.65359 15.2477 2.75402C15.3481 2.85445 15.2948 3.04213 15.1881 3.41748Z"
      stroke={fillColor}
    />
  </svg>
);

export default ConfettiShape;
